import { model as i18n } from '!/i18n'
import { extendMediaItemByLabelPrice } from '@/tools'
import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'

export const $subCategoriesWithVodsFormatted = combine(
  api.vods.$subCategoriesWithVods,
  ssePurchasesModel.$vod,
  i18n.$t,
  (subCategoriesWithVods, adjust, { t }) => {
    const data =
      subCategoriesWithVods?.length > 0
        ? subCategoriesWithVods.map((category) => {
            const vods = category.content.map((vod) =>
              extendMediaItemByLabelPrice(adjust(vod))
            )
            const genresText = t('genre_other')

            return {
              ...category,
              content: vods,
              nameFormatted: `${category.name} ${genresText}`,
            }
          })
        : null

    return data
  }
)
